import RemoveIcon from "@mui/icons-material/Remove";
import type { SvgIconProps } from "@mui/material/SvgIcon";

type NoValueDashProps = {
  fontSize?: SvgIconProps["fontSize"];
};

/**
 * The dash a table cell, card or field shows where it has no value.
 *
 * An SVG icon rather than `<Icon>remove</Icon>`. That form renders a Material Icons *ligature* — the
 * literal text "remove", which the browser draws as a dash only once the icon font fetched from
 * Google Fonts has applied. `MuiIcon-root` is `width: 1em; overflow: hidden`, so anywhere that font
 * has not applied — an environment with no route to the CDN, a blocked request, or simply the moment
 * before it loads — the cell shows the first 1em of the word instead: a clipped "re" at 24px against
 * 14px table text. An SVG icon is bundled with the app and cannot fail that way.
 *
 * Small by default, to sit on the body2 line of a compact table cell.
 */
export function NoValueDash(props: Readonly<NoValueDashProps>) {
  return <RemoveIcon fontSize={props.fontSize ?? "small"} />;
}
